<template>
  <div class="columns is-multiline is-mobile">
    <div class="column">
      <window title="Basics" height="100%">
        <div class="">
          <b-radio v-model="radio" native-value="Flint">
            Flint
          </b-radio>
          <b-radio v-model="radio" native-value="Silver">
            Silver
          </b-radio>
          <b-radio v-model="radio" native-value="Jack">
            Jack
          </b-radio>
          <b-radio v-model="radio" native-value="Vane" disabled>
            Vane
          </b-radio>
        </div>
        <p class="content">
          <b>Selection:</b>
          {{ radio }}
        </p>
      </window>
    </div>
    <div class="column">
      <window title="Sizes" height="100%">
        <div class="field">
          <b-radio v-model="radio2" size="is-small" native-value="small">
            Small
          </b-radio>
        </div>
        <div class="field">
          <b-radio v-model="radio2" native-value="default">
            Default
          </b-radio>
        </div>
        <div class="field">
          <b-radio v-model="radio2" size="is-medium" native-value="medium">
            Medium
          </b-radio>
        </div>
        <div class="field">
          <b-radio v-model="radio2" size="is-large" native-value="large">
            Large
          </b-radio>
        </div>
      </window>
    </div>
    <div class="column">
      <window title="Button style" height="100%">
        <b-field>
          <b-radio-button v-model="radioButton" native-value="Nop" type="is-danger">
            <b-icon icon="close"></b-icon>
            <span>Nop</span>
          </b-radio-button>

          <b-radio-button v-model="radioButton" native-value="Yep" type="is-success">
            <b-icon icon="check"></b-icon>
            <span>Yep</span>
          </b-radio-button>

          <b-radio-button v-model="radioButton" native-value="Default">
            Default
          </b-radio-button>

          <b-radio-button v-model="radioButton" native-value="Disabled" disabled>
            Disabled
          </b-radio-button>
        </b-field>
        <p class="content">
          <b>Selection:</b>
          {{ radioButton }}
        </p>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: 'Vane',
      radio2: 'Vane',
      radioButton: '',
    };
  },
};
</script>
